<h2 mat-dialog-title>Register Local Credential</h2>
<form [formGroup]="localForm">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" required>
      @if (localForm.get('username')?.hasError('required')) {
        <mat-error>Username is required</mat-error>
      }
    </mat-form-field>

    <!-- Show passwordOptions only if isForRemoteUser is true -->
    @if (isForRemoteUser) {
      <mat-form-field>
        <mat-label>Password Options</mat-label>
        <mat-select formControlName="passwordOptions">
          <mat-option value="customPassword">Set a password on behalf of the user</mat-option>
          <mat-option value="letTheUserChooseOne">Send an email and let the user set a password</mat-option>
        </mat-select>
      </mat-form-field>
    }

    <!-- Show password field based on the conditions defined in updatePasswordFieldVisibility() -->
    @if (!isForRemoteUser || localForm.get('passwordOptions')?.value === 'customPassword') {
      <div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" required autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
          @if (localForm.get('password').hasError('required')) {
            <mat-error>
              New Password is required
            </mat-error>
          }
        </mat-form-field>
        <p>
          <app-password-strength [control]="localForm.get('password')"></app-password-strength>
        </p>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Re-type Password</mat-label>
          <input matInput type="password" formControlName="passwordConfirmation" required autocomplete="new-password" passwordrules="required: upper; required: lower; required: digit; required: [-().&@?'#,/&quot;+]" />
        </mat-form-field>
        @if (localForm.hasError('mismatch')) {
          <div>
            Passwords do not match.
          </div>
        }
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="localForm.invalid" (click)="onSubmit()">Submit</button>
  </mat-dialog-actions>
</form>
